// ProfileNavigation helper functions and data
import React from "react";

import { ProfileNavigationTab } from "./ProfileNavigation.types";
import CONSTANTS from "config/constants";

import ArticleSVG from "../../../../public/assets/images/article.svg";
import BookSVG from "../../../../public/assets/images/book.svg";
import CouponSVG from "../../../../public/assets/images/coupons.svg";
import HeartLineSVG from "../../../../public/assets/images/heart-line.svg";
import HelpSVG from "../../../../public/assets/images/help.svg";
import HistorySVG from "../../../../public/assets/images/history.svg";
import LocationSVG from "../../../../public/assets/images/location.svg";
import NotificationsSVG from "../../../../public/assets/images/notifications.svg";
import StoreSVG from "../../../../public/assets/images/store.svg";

const { FEATURE_FLAGS } = CONSTANTS;
const { WITH_WISHLIST, WITH_COUPONS, WITH_DELIVERY } = FEATURE_FLAGS;
const { WITH_PURCHASE } = FEATURE_FLAGS;

export const tabs = (t: any): (ProfileNavigationTab | null)[] => [
  WITH_PURCHASE
    ? {
        icon: <HistorySVG className="ProfileNavigation__tab-icon" />,
        tabName: `${t.profile.navigation.orderHistory}`,
        isExternal: false,
        url: "/profile/orders",
        authenticated: true
      }
    : null,
  WITH_WISHLIST
    ? {
        icon: <HeartLineSVG className="ProfileNavigation__tab-icon" />,
        tabName: `${t.profile.navigation.wishList}`,
        isExternal: false,
        url: "/profile/wishlist",
        authenticated: false
      }
    : null,
  WITH_COUPONS
    ? {
        icon: <CouponSVG className="ProfileNavigation__tab-icon" />,
        tabName: `${t.profile.navigation.coupons}`,
        isExternal: false,
        url: "/profile/coupons",
        authenticated: true
      }
    : null,
  WITH_DELIVERY
    ? {
        icon: <LocationSVG className="ProfileNavigation__tab-icon" />,
        tabName: `${t.profile.navigation.deliveryAddress}`,
        isExternal: false,
        url: "/profile/addresses",
        authenticated: false
      }
    : null,
  {
    icon: <StoreSVG className="ProfileNavigation__tab-icon" />,
    tabName: `${t.profile.navigation.stores}`,
    isExternal: false,
    url: "/profile/stores",
    authenticated: true
  },
  WITH_PURCHASE
    ? {
        icon: <ArticleSVG className="ProfileNavigation__tab-icon" />,
        tabName: `${t.profile.navigation.billing}`,
        isExternal: false,
        url: "/profile/billing",
        authenticated: false
      }
    : null,
  {
    icon: <NotificationsSVG className="ProfileNavigation__tab-icon" />,
    tabName: `${t.profile.navigation.notifications}`,
    isExternal: false,
    url: "/profile/notifications",
    authenticated: false
  },
  {
    icon: <BookSVG className="ProfileNavigation__tab-icon" />,
    tabName: `${t.profile.navigation.legalTerms}`,
    isExternal: false,
    url: "/profile/terms",
    authenticated: true
  },

  {
    icon: <HelpSVG className="ProfileNavigation__tab-icon" />,
    tabName: `${t.profile.navigation.support}`,
    isExternal: false,
    url: "/profile/support",
    authenticated: true
  }
];
